import {
  Button,
  Form,
  Modal,
  Row,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  searchBuyerForTransferCampaign,
  transferCampaignToBuyer,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

const TransferCampaignToBuyer = ({
  setTransferCampaignFlag,
  transferCampaignFlag,
  campaignId,
}) => {
  const [buyersListForCampaign, setBuyersListForCampaigns] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { buyersList, searchBuyerToTransferLoading: searchEmailLoader } =
    useSelector((state) => state.sellerCampaigns);
  const { transferCampaignLoading } = useSelector(
    (state) => state.buyerCampaigns
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchText) {
        dispatch(searchBuyerForTransferCampaign(searchText));
      }
    }, 500);

    return () => {
      clearTimeout(delayDebounce);
    };
  }, [searchText]);

  const [form] = Form.useForm();

  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setBuyersListForCampaigns([]);
      form.setFieldsValue({ transfer_email: undefined });
      return;
    }
  };

  const handleTransferCampaign = (values) => {
    const buyer = form.getFieldValue("transfer_email")
      ? buyersListForCampaign?.find(
          (buyer) => buyer.value === form.getFieldValue("transfer_email")
        )
      : undefined;
    values.transfer_email = buyer.label;
    const payload = {
      campaign_id: campaignId,
      comments: values.comments,
      transfer_email: values.transfer_email,
      transfer_status: 1,
    };
    dispatch(transferCampaignToBuyer(payload)).then(() => {
      setTransferCampaignFlag(false);
      setBuyersListForCampaigns([]);
      form.resetFields();
      navigate("/buyer/mycampaigns");
    });
  };

  useEffect(() => {
    if (buyersList) {
      const v =
        buyersList &&
        buyersList?.map((buyer, index) => ({
          label: buyer.email,
          value: buyer.id,
        }));
      setBuyersListForCampaigns(v);
    }
  }, [buyersList]);

  return (
    <>
      <Modal
        open={transferCampaignFlag}
        onCancel={() => {
          form.resetFields();
          setTransferCampaignFlag(false);
          setBuyersListForCampaigns([]);
        }}
        centered
        footer={false}
      >
        <Row>
          <Text
            className="share-camapign-model-header"
            style={{ fontSize: "20px" }}
          >
            Are you Sure! you want Transfer this campaign ?
          </Text>
        </Row>
        <Form form={form} onFinish={handleTransferCampaign}>
          <Form.Item
            name="transfer_email"
            rules={[
              {
                required: true,
                message: "Email is required!",
              },
            ]}
          >
            <FloatingSelect
              showSearch
              allowClear
              className="billboard-select-feild"
              onSearch={(val) => handleSearch(val)}
              label={<>{`Email`}</>}
              loading={searchEmailLoader}
              optionFilterProp="label"
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              isDma={true}
              isRequired={true}
              options={buyersListForCampaign}
              customStyles={floatingSelectStyles}
            />
          </Form.Item>
          <Form.Item
            name="comments"
            rules={[
              {
                required: true,
                message: "Comments is required!",
              },
            ]}
          >
            <FloatingTextArea
              customStyles={textAreaFloatingInputStyles}
              label={<>{`Comments*`}</>}
              className="billboard-input-feild billboard-text-area"
            ></FloatingTextArea>
          </Form.Item>

          <Row justify="end" style={{ gap: "0.5rem" }}>
            <Button
              className="billboard-buttons billboard-button-1"
              onClick={(e) => {
                form.resetFields();
                setTransferCampaignFlag(false);
                setBuyersListForCampaigns([]);
              }}
            >
              Cancel
            </Button>
            <Button
              className="billboard-buttons billboard-button-2"
              htmlType="submit"
            >
              Transfer
            </Button>
          </Row>
        </Form>

        {transferCampaignLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </Modal>
    </>
  );
};

export default TransferCampaignToBuyer;
